export default "__VITE_ASSET__BY17jGGA__"